import React from "react";
import { Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const HelpTooltip = ({ title, children }) => {
	return (
		<Popover
			title={title}
			content={children}
			trigger="click"
			style={{ maxWidth: 400 }}
		>
			<QuestionCircleOutlined style={{ color: "#1890ff" }} />
		</Popover>
	);
};

export default HelpTooltip;
